'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Sheet, SheetContent, SheetHeader } from '@/components/ui/sheet';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { CtaSectionProps } from '@/app/(main)/(pages)/(institucional)/(index)/_components/cta/cta-section.component';
import BranchShareItem from '@/app/(main)/(pages)/(institucional)/(index)/_components/cta/modals/branch-share-item.component';

interface CtaModalBranchesListProps extends Omit<CtaSectionProps, 'originCta'> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function CtaModalBranchesList({
  procedure,
  searchType,
  branches,
  place,
  open,
  onOpenChange,
}: CtaModalBranchesListProps) {
  if (!branches?.length) {
    return null;
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="centerFit"
        closingTagPosition="right"
      >
        <SheetHeader>
          <Typography
            variant={TypographyVariant.MODAL_TITLE}
            className="font-bold"
          >
            Selecione a unidade
          </Typography>
        </SheetHeader>

        <div data-testid={DataTestIdEnum.SEO_CTA_SCHEDULE_MULTIPLE_BRANCHES_MODAL} className="flex-1 min-h-0 overflow-y-auto pt-4">
          <Typography>
            Entre em contato com a unidade física que oferece este atendimento:
          </Typography>

          <hr className="mt-6 px-5" />

          {branches.map((branch, index, currentArray) => (
            <div key={branch?.id} className="mt-6">
              <BranchShareItem
                branch={branch}
                procedure={procedure}
                place={place}
                searchType={searchType}
              />

              {currentArray.length - 1 !== index && (
                <hr className="mt-6 px-5" />
              )}
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
